import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { trackBusinessError } from '@sxm-de/dev-kits/web-sdk/utils';

interface LogCreateStripePaymentMethodErrorFnPayload {
    type?: string;
    code?: string;
    message?: string;
}

export type LogCreateStripePaymentMethodErrorFn = (
    payload: LogCreateStripePaymentMethodErrorFnPayload,
) => Promise<unknown>;

export function initLogCreateStripePaymentMethodErrorFn({
    dependencies,
}: DomainInitPayload): LogCreateStripePaymentMethodErrorFn {
    const { appEventSdk } = dependencies;
    return async (error: LogCreateStripePaymentMethodErrorFnPayload) => {
        const { code, message, type } = error as {
            code: string;
            message: string;
            type: string;
        };
        if (type === 'card_error') {
            trackBusinessError(appEventSdk, { code, message });
        } else {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
        }
    };
}
